import { cn } from '@up2stay/up2promo-ui';
import type { ReactNode } from 'react';

export function BillingCard({
  children,
  className,
  as: Comp = 'section',
  'aria-label': ariaLabel,
}: {
  children: ReactNode;
  className?: string;
  as?: 'section' | 'div';
  'aria-label'?: string;
}) {
  return (
    <Comp
      aria-label={ariaLabel}
      className={cn(
        'flex flex-col gap-4 rounded-[18px] border border-border bg-card p-[18px]',
        'sm:gap-5 sm:p-6',
        'dark:border-border/80',
        className,
      )}
    >
      {children}
    </Comp>
  );
}

export function BillingCardTitle({
  children,
  className,
}: {
  children: ReactNode;
  className?: string;
}) {
  return (
    <h2
      className={cn(
        'm-0 text-lg font-semibold tracking-[-0.02em] text-foreground',
        className,
      )}
    >
      {children}
    </h2>
  );
}

export function BillingChip({
  children,
  className,
}: {
  children: ReactNode;
  className?: string;
}) {
  return (
    <span
      className={cn(
        'inline-flex items-center rounded-full bg-muted px-2.5 py-0.5',
        'text-[12px] font-semibold text-muted-foreground',
        className,
      )}
    >
      {children}
    </span>
  );
}

export function BillingPlusBadge({ label }: { label: string }) {
  return (
    <span
      className={cn(
        'inline-flex items-center rounded-md bg-muted px-1.5 py-0.5',
        'text-[11px] font-semibold text-muted-foreground',
      )}
    >
      {label}
    </span>
  );
}
